import * as React from 'react';
import { Router, Route, hashHistory } from 'react-router';
import { SetupComplete } from './SetupComplete';
import { SetupExtension } from '../pages/SetupExtension';

export const Onboarding = () => (
  <div className="Onboarding">
    <Router history={hashHistory}>
      <Route path="/" component={SetupExtension} />
      <Route path="/setup-complete" component={SetupComplete} />
    </Router>
  </div>
);
